import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
(function () {


    document.addEventListener('DOMContentLoaded', () => {
        const sliders = document.querySelectorAll('.slider .swiper');
        if (sliders) {
            console.log("got some sliders")
            sliders.forEach((element) => {
                const id = element.id.replace(/swiper-/, "")
                var swiperid = "#swiper-" + id;
                console.log(element)
                const s = new Swiper(element, {
                    modules: [Navigation, Pagination],
                    slidesPerView: 1,
                    loop: true,
                    navigation: {
                        nextEl: "#slider-next-" + id,
                        prevEl: "#slider-prev-" + id,
                    },
                    pagination: {
                        el: '#swiper-pagination-' + id,
                        type: 'bullets',
                        clickable: true,
                    },
                })
                console.log(s)
            })
        }
    })

})();